import { QuestionAnswerArticleEvaluation } from "@prisma/client";

export type QaArticleEvaluation = QuestionAnswerArticleEvaluation;

export const QA_ARTICLE_EVALUATION_TYPES: QaArticleEvaluation["type"][] = [
  "convincing",
  "informative",
  "easyToUnderstand",
  "hardToUnderstand",
];

export const POSITIVE_QA_ARTICLE_EVALUATION_TYPES: QaArticleEvaluation["type"][] =
  ["convincing", "easyToUnderstand", "informative"];

export function isValidQaArticleEvaluationType(type: any) {
  return QA_ARTICLE_EVALUATION_TYPES.includes(type);
}

export function isPositiveEvaluationType(type: QaArticleEvaluation["type"]) {
  return POSITIVE_QA_ARTICLE_EVALUATION_TYPES.includes(type);
}

export function getArticleEvaluationDisplayName(
  type: QaArticleEvaluation["type"]
) {
  switch (type) {
    case "convincing":
      return "説得力がある";
    case "easyToUnderstand":
      return "わかりやすい";
    case "hardToUnderstand":
      return "わかりずらい";
    case "informative":
      return "学びになる";
  }
}
